import { render, staticRenderFns } from "./formatcurrency.vue?vue&type=template&id=178f97df&"
import script from "./formatcurrency.vue?vue&type=script&lang=js&"
export * from "./formatcurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('178f97df')) {
      api.createRecord('178f97df', component.options)
    } else {
      api.reload('178f97df', component.options)
    }
    module.hot.accept("./formatcurrency.vue?vue&type=template&id=178f97df&", function () {
      api.rerender('178f97df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24CwhT4Hl8rws/JS/formatcurrency.vue"
export default component.exports